/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumFacilityExternalIdSource = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "email" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "none" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "sms" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "voice" | "webedoctor" | "webpt" | "%future added value";
export type EnumFacilityIntegrator = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "webedoctor" | "webpt" | "%future added value";
export type FilterFindManyFacilityInput = {
    user?: string | null | undefined;
    name?: string | null | undefined;
    alternativeName?: string | null | undefined;
    phonetic?: string | null | undefined;
    address?: string | null | undefined;
    city?: string | null | undefined;
    state?: string | null | undefined;
    country?: string | null | undefined;
    postcode?: string | null | undefined;
    phone?: string | null | undefined;
    fax?: string | null | undefined;
    alternativePhone?: string | null | undefined;
    visible?: boolean | null | undefined;
    specialInstructions?: string | null | undefined;
    integrator?: EnumFacilityIntegrator | null | undefined;
    externalId?: FacilityExternalIdInput | null | undefined;
    setting?: string | null | undefined;
    settings?: unknown | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    deleted?: number | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    _id?: string | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyFacilityInput | null | undefined;
    OR?: Array<FilterFindManyFacilityInput> | null | undefined;
    AND?: Array<FilterFindManyFacilityInput> | null | undefined;
};
export type FacilityExternalIdInput = {
    source?: EnumFacilityExternalIdSource | null | undefined;
    value?: string | null | undefined;
    _id?: string | null | undefined;
};
export type OperatorsFilterFindManyFacilityInput = {
    user?: UserOperatorsFilterFindManyFacilityInput | null | undefined;
    name?: NameOperatorsFilterFindManyFacilityInput | null | undefined;
    alternativeName?: AlternativeNameOperatorsFilterFindManyFacilityInput | null | undefined;
    phonetic?: PhoneticOperatorsFilterFindManyFacilityInput | null | undefined;
    address?: AddressOperatorsFilterFindManyFacilityInput | null | undefined;
    city?: CityOperatorsFilterFindManyFacilityInput | null | undefined;
    state?: StateOperatorsFilterFindManyFacilityInput | null | undefined;
    country?: CountryOperatorsFilterFindManyFacilityInput | null | undefined;
    postcode?: PostcodeOperatorsFilterFindManyFacilityInput | null | undefined;
    phone?: PhoneOperatorsFilterFindManyFacilityInput | null | undefined;
    fax?: FaxOperatorsFilterFindManyFacilityInput | null | undefined;
    alternativePhone?: AlternativePhoneOperatorsFilterFindManyFacilityInput | null | undefined;
    visible?: VisibleOperatorsFilterFindManyFacilityInput | null | undefined;
    specialInstructions?: SpecialInstructionsOperatorsFilterFindManyFacilityInput | null | undefined;
    integrator?: IntegratorOperatorsFilterFindManyFacilityInput | null | undefined;
    externalId?: ExternalIdOperatorsFilterFindManyFacilityInput | null | undefined;
    externalRawSource?: ExternalRawSourceOperatorsFilterFindManyFacilityInput | null | undefined;
    setting?: SettingOperatorsFilterFindManyFacilityInput | null | undefined;
    settings?: SettingsOperatorsFilterFindManyFacilityInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyFacilityInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyFacilityInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyFacilityInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyFacilityInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyFacilityInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyFacilityInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyFacilityInput | null | undefined;
    _id?: _idOperatorsFilterFindManyFacilityInput | null | undefined;
};
export type UserOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type NameOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AlternativeNameOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PhoneticOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AddressOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CityOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StateOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CountryOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PostcodeOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PhoneOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FaxOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AlternativePhoneOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type VisibleOperatorsFilterFindManyFacilityInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type SpecialInstructionsOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type IntegratorOperatorsFilterFindManyFacilityInput = {
    gt?: EnumFacilityIntegrator | null | undefined;
    gte?: EnumFacilityIntegrator | null | undefined;
    lt?: EnumFacilityIntegrator | null | undefined;
    lte?: EnumFacilityIntegrator | null | undefined;
    ne?: EnumFacilityIntegrator | null | undefined;
    in?: Array<EnumFacilityIntegrator | null> | null | undefined;
    nin?: Array<EnumFacilityIntegrator | null> | null | undefined;
    regex?: EnumFacilityIntegrator | null | undefined;
};
export type ExternalIdOperatorsFilterFindManyFacilityInput = {
    gt?: FacilityExternalIdInput | null | undefined;
    gte?: FacilityExternalIdInput | null | undefined;
    lt?: FacilityExternalIdInput | null | undefined;
    lte?: FacilityExternalIdInput | null | undefined;
    ne?: FacilityExternalIdInput | null | undefined;
    in?: Array<FacilityExternalIdInput | null> | null | undefined;
    nin?: Array<FacilityExternalIdInput | null> | null | undefined;
    regex?: FacilityExternalIdInput | null | undefined;
};
export type ExternalRawSourceOperatorsFilterFindManyFacilityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type SettingOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SettingsOperatorsFilterFindManyFacilityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyFacilityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyFacilityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DeletedOperatorsFilterFindManyFacilityInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedByOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyFacilityInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type _idOperatorsFilterFindManyFacilityInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FilterFacilityDataQueryVariables = {
    filter?: FilterFindManyFacilityInput | null | undefined;
};
export type FilterFacilityDataQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FilterFacilityList_Query">;
};
export type FilterFacilityDataQuery = {
    readonly response: FilterFacilityDataQueryResponse;
    readonly variables: FilterFacilityDataQueryVariables;
};



/*
query FilterFacilityDataQuery(
  $filter: FilterFindManyFacilityInput
) {
  ...FilterFacilityList_Query
}

fragment FilterFacilityList_Query on Query {
  facilityConnection(first: 25, filter: $filter, sort: NAME_ASC) {
    edges {
      node {
        _id
        name
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "NAME_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterFacilityDataQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FilterFacilityList_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterFacilityDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FacilityConnection",
        "kind": "LinkedField",
        "name": "facilityConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FacilityEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "FilterFacilityList_facilityConnection",
        "kind": "LinkedHandle",
        "name": "facilityConnection"
      }
    ]
  },
  "params": {
    "cacheID": "1ad9260114942c9e39d1ed0b30ecadfc",
    "id": null,
    "metadata": {},
    "name": "FilterFacilityDataQuery",
    "operationKind": "query",
    "text": "query FilterFacilityDataQuery(\n  $filter: FilterFindManyFacilityInput\n) {\n  ...FilterFacilityList_Query\n}\n\nfragment FilterFacilityList_Query on Query {\n  facilityConnection(first: 25, filter: $filter, sort: NAME_ASC) {\n    edges {\n      node {\n        _id\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '047cc34bbc1877b67ea56a0631fb1e12';
export default node;
